import { PetVerificationStatusEnum } from "./types";

export const PetVerificationStatusMap = {
  [PetVerificationStatusEnum.VERIFIED]: "Verified",
  [PetVerificationStatusEnum.NOT_VERIFIED]: "Not verified",
  [PetVerificationStatusEnum.NONE]: "Not verified"
};
